/*
  Leaving prompt - displays waring when navigating away from unsaved changes in a form.
  Leverages React Router <Prompt /> which is designed to show the browser built in confirm dialog.
  Instead of showing the browser dialog, we show our own modal.
*/

import React from 'react';
import styled from '@emotion/styled';
import SimpleModal from 'ui_system/forms/SimpleModal';
import { Theme } from 'ui_system/theme';
import {
  CancelButton,
  OkButton,
  Actions,
  Text,
  Label,
} from 'ui_system/forms/FormStyles';
import { t } from 'services/translation';

const ChangesModal = styled(SimpleModal)`
  padding: 35px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    overflow-x: hidden;
  }
`;

const CancelBtn = styled(CancelButton)`
  background: transparent;
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  color: ${Theme.colors.secondaryTextColor};
  padding: 8px 20px;
  height: ${Theme.forms.dimensions.inputHeight}px;
  &:hover {
    background-color: ${Theme.colors.backgroundColor};
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 100%;
    order: 2;
  }
`;

const OkBtn = styled(OkButton)`
  background: ${(props) =>
    props.brandColor
      ? props.brandColor
      : Theme.colors.linksDesignElementsBaseColor};
  padding: 8px 20px;
  width: 150px;
  height: ${Theme.forms.dimensions.inputHeight}px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 100%;
    order: 1;
  }
`;

const LeavingActions = styled(Actions)`
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    grid-template-columns: 100%;
    grid-gap: 15px;
  }
`;

export class LeavingPrompt extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { showChangesModal, onClose, brandColor } = this.props;
    return (
      <div>
        <ChangesModal
          padding={40}
          maxHeight={230}
          width={420}
          open={showChangesModal}
          close={() => onClose('close')}
          preventClickOff
          mobileMaxHeight={276}
        >
          <Label allowWrap block>
            {t('YOU_HAVE_UNSAVED_CHANGES_ON_THIS_SCREEN')}
          </Label>
          <Text small>
            {t(
              'ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_SCREEN_AND_DISCARD_THIS_INFORMATION'
            )}
          </Text>
          <LeavingActions alignItems="center">
            <CancelBtn
              data-testid="discard-btn"
              justify="start"
              onClick={() => onClose('discard')}
            >
              {t('DISCARD')}
            </CancelBtn>
            <OkBtn
              brandColor={brandColor}
              justify="end"
              onClick={() => onClose('save')}
            >
              {t('SAVE_CHANGES')}
            </OkBtn>
          </LeavingActions>
        </ChangesModal>
      </div>
    );
  }
}
export default LeavingPrompt;
//
